/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_Boundary_Technical_DetailsInputs */

const nl_common_error_boundary_technical_details = /** @type {(inputs: Common_Error_Boundary_Technical_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische details`)
};

/**

* @param {Common_Error_Boundary_Technical_DetailsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_error_boundary_technical_details = /** @type {((inputs?: Common_Error_Boundary_Technical_DetailsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Boundary_Technical_DetailsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_error_boundary_technical_details(inputs)
});
export { common_error_boundary_technical_details as "common.error_boundary_technical_details" }